import { Inject, Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'PropertyKey' })
export class cmsTablePropertyKeyPipe implements PipeTransform {
  transform(e: any, propKey: any, isBoolean: any, booleanOption: any) {
    let prop = e;
    if (propKey && e) {
      if (propKey.includes('.')) {
        const array = propKey.split('.');
        for (let i = 0; i < array.length; i++) {
          prop = prop[array[i]] ?? '';
        }
        return prop;
      }
      return e[propKey];
    }
    if (isBoolean)
    {
      if (!booleanOption) return e;
      
      // Try to find the value in booleanOption, checking multiple key formats
      if (booleanOption[e] !== undefined) {
        return booleanOption[e];
      }
      // Convert boolean to number (1 or 0) for lookup
      const numKey = e === true || e === 'true' || e === 1 || e === '1' ? 1 : 0;
      if (booleanOption[numKey] !== undefined) {
        return booleanOption[numKey];
      }
      // Convert to string key for boolean lookup
      const stringKey = e === true || e === 'true' || e === 1 || e === '1' ? 'true' : 'false';
      if (booleanOption[stringKey] !== undefined) {
        return booleanOption[stringKey];
      }
      return e;
    }
    return e;
  }
}
